export function makeMaxCharactersValidator<T>(maxCharacters: number, errorMsg: T) {
  return (value: string) => {
    const validatingValue = value || '';
    if (validatingValue?.length > maxCharacters) {
      return errorMsg;
    }
    return undefined;
  };
}
